import DashboardImage from "../../../../content/articles/2015-01-31-when-your-rails-app-slows-to-a-crawl/heroku-books-dashboard.png";
import React from 'react';
export default {
  DashboardImage,
  React
};